import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Lightbox from '@/components/Lightbox'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/projects/:uid',
      name: 'project',
      component: Lightbox,
      props: true
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./client/router/index.js